<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MJtY7z/tc-custom/9780765388773.jpg?1718183454722" alt="This image is the cover for the book Guns Above, The Signal Airship Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Guns Above, The Signal Airship Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Robyn Bennis’s THE GUNS ABOVE is an adventurous military fantasy debut about a nation's first female airship captain.</b><br/><b><br/>They say it’s not the fall that kills you. <br/></b><br/>For Josette Dupre, the Corps’ first female airship captain, it might just be a bullet in the back. <br/><br/>On top of patrolling the front lines, she must also contend with a crew who doubts her expertise, a new airship that is an untested deathtrap, and the foppish aristocrat Lord Bernat, a gambler and shameless flirt with the military know-how of a thimble. Bernat’s own secret assignment is to catalog her every moment of weakness and indecision. <br/><br/>So when the enemy makes an unprecedented move that could turn the tide of the war, can Josette deal with Bernat, rally her crew, and survive long enough to prove herself?<br/><br/>“Full of sass and terrific characters. Great storytelling.  Loved it.” —Patricia Briggs<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robyn Bennis
      </h2>
      
      <p class="authorDescription body article">ROBYN BENNIS works in biotech but dreams of airships. She lives in Mountain View, CA, within sight of the historic Hangar One at Moffett Federal Airfield. <I>The Guns Above</I> is her debut novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27d4b60c